<template>
    <el-dialog :title="title + '功能页配置信息'" :fullscreen="true" :close-on-click-modal="false" append-to-body
               :visible.sync="visible">
        <el-steps :active="step" align-center class="m_b1" v-if="method == 'add'">
            <el-step title="基本设置"></el-step>
            <el-step title="数据设置"></el-step>
            <el-step title="完成"></el-step>
        </el-steps>
        <div v-loading="loading">
            <el-form class="form" size="small" :inline="true" :model="form" ref="form" label-width="160px"
                     :rules="dataRule"
                     :disabled="method==='view'" v-show="step == 0">
                <el-form-item label="功能（页面）名称：" prop="tableName" class="formItem">
                    <el-input v-model.trim="form.tableName" placeholder="请输入名称（限10字）" clearable
                              maxlength="10"></el-input>
                </el-form-item>
                <el-form-item label="元数据模板：" prop="basicDataId" class="formItem">
                    <el-select class="w100i" v-model="form.basicDataId" placeholder="请选择" clearable filterable multiple
                               @change="selBasicData">
                        <el-option
                                :key="item.id"
                                :label="item.basicDataName"
                                :value="item.id" :disabled="item.disabled"
                                v-for="item in basicDataIdListOpt">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="功能模板：" prop="metadataFonctionsModelId" class="formItem">
                    <el-select class="w100i" v-model="form.metadataFonctionsModelId" placeholder="请选择" clearable
                               filterable @change="selFunctionTemplate">
                        <el-option
                                :key="item.id"
                                :label="item.modelName"
                                :value="item.id"
                                v-for="item in metadataFonctionsOpt">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="默认行数：" prop="defautNombre" class="formItem">
                    <el-select class="w100i" v-model="form.defautNombre" placeholder="请选择">
                        <el-option v-for="(e, i) in  $dictUtils.getDictList('pagination')" :key="i"
                                   :label="e.label"
                                   :value="e.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="功能（页面）描述：" prop="tableDescription" class="formItem">
                    <el-input v-model.trim="form.tableDescription" placeholder="请输入描述信息（限200字）" clearable
                              maxlength="200"
                              type="textarea" :rows="1" v-if="visible"></el-input>
                </el-form-item>
                <div class="title">
                    页面加载设置
                    <el-tooltip class="item" effect="light"
                                content="仅支持设置单行文本、多行文本、下拉单选、单选框组、下拉多选、多选框组、时间选择框、日期选择框、switch开关、数字 组件类型的元数据"
                                placement="right">
                        <el-link icon="el-icon-question" type="primary" :underline="false"></el-link>
                    </el-tooltip>
                </div>
                <el-form-item label="创建人：" prop="forCreate" class="formItem">
                    <el-checkbox v-model="form.forCreate" true-label="0" false-label="1">当前登陆用户</el-checkbox>
                </el-form-item>
                <div>
                    <el-form-item class="w100i" :label="item.basicDataName+ '：'"
                                  v-for="(item, index) in form.basicDataIdList" :key="index">
                        <div v-for="(itemC, indexC) in item.metadataTableConfigLoadsettings" :key="indexC">
                            <el-form-item
                                    :prop="`basicDataIdList[${index}].metadataTableConfigLoadsettings[${indexC}].conditionApproach`"
                                    label-width="0px">
                                <el-select v-model="itemC.conditionApproach" placeholder="请选择" class="methodSel">
                                    <el-option v-for="(e, i) in  $dictUtils.getDictList('conditionApproach')" :key="i"
                                               :label="e.label"
                                               :value="e.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                    :prop="`basicDataIdList[${index}].metadataTableConfigLoadsettings[${indexC}].basicDataDetailId`"
                                    :rules="[{required: true, message: '元数据不能为空', trigger: 'change'}]"
                                    label-width="10px">
                                <el-select v-model="itemC.basicDataDetailId" placeholder="请选择" filterable
                                           @change="archivesChange(item, itemC)">
                                    <el-option v-for="c in item.children" :key="c.id" :label="c.basicRename"
                                               :value="c.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                    :prop="`basicDataIdList[${index}].metadataTableConfigLoadsettings[${indexC}].condition`"
                                    :rules="[{required: true, message: '条件不能为空', trigger: 'change'}]"
                                    label-width="10px">
                                <el-select v-model="itemC.condition" placeholder="请选择" @change="conditionChange(itemC)">
                                    <el-option
                                            :key="v.value"
                                            :label="v.label"
                                            :value="v.value"
                                            v-for="v in getMethodCode(itemC)">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                    :prop="`basicDataIdList[${index}].metadataTableConfigLoadsettings[${indexC}].detailList`"
                                    :rules="[{required: true, message: '条件值不能为空', trigger: 'change'}, validatorDataRule(itemC)]"
                                    v-if="itemC.condition && itemC.condition != '=null' && itemC.condition != '!=null'"
                                    label-width="10px">
                                <!--单行文本-->
                                <el-input v-model.trim="itemC.detailList" placeholder="请输入"
                                          :maxlength="itemC.metadataBasicDataRuleVo && itemC.metadataBasicDataRuleVo.ruleMax ? (itemC.metadataBasicDataRuleVo.ruleMax)*1 : 200"
                                          clearable
                                          v-if="itemC.basicAssemblyId == '1'"></el-input>
                                <!--多行文本-->
                                <el-input v-model.trim="itemC.detailList" placeholder="请输入"
                                          :maxlength="itemC.metadataBasicDataRuleVo && itemC.metadataBasicDataRuleVo.ruleMax ? (itemC.metadataBasicDataRuleVo.ruleMax)*1 : 2000"
                                          type="textarea"
                                          :rows="1" v-if="itemC.basicAssemblyId == '2'"></el-input>
                                <!--数字-->
                                <el-input v-model.trim="itemC.detailList" placeholder="请输入" clearable maxlength="19"
                                          @input="(v)=>(itemC.detailList=v.replace(/[^\d-.]/g,''))"
                                          v-if="itemC.basicAssemblyId == '12'"></el-input>
                                <!--下拉单选、单选框组、下拉多选、多选框组-->
                                <el-select v-model="itemC.detailList"
                                           :multiple="itemC.basicAssemblyId == '6' || itemC.basicAssemblyId == '7'"
                                           placeholder="请选择" clearable
                                           v-if="itemC.basicAssemblyId == '4' || itemC.basicAssemblyId == '5' || itemC.basicAssemblyId == '6' || itemC.basicAssemblyId == '7' || itemC.basicAssemblyId == '10'">
                                    <el-option v-for="(v,i) in itemC.basicRangeList" :key="i"
                                               :label="v.basicRange"
                                               :value="v.metadataRangeId"></el-option>
                                </el-select>
                                <!--时间-->
                                <el-time-picker v-model="itemC.detailList" placeholder="请选择"
                                                value-format="yyyy-MM-dd HH:mm:ss" format="HH:mm:ss"
                                                clearable v-if="itemC.basicAssemblyId == '8'"></el-time-picker>
                                <!--日期-->
                                <el-date-picker class="w100i"
                                                v-model="itemC.detailList" value-format="yyyy-MM-dd HH:mm:ss"
                                                :format="itemC.metadataBasicDataRuleVo ? itemC.metadataBasicDataRuleVo.ruleDateFormat : 'yyyy-MM-dd HH:mm:ss'"
                                                :type="setDatePickerType(itemC)"
                                                clearable placeholder="请选择"
                                                v-if="itemC.basicAssemblyId == '9'"></el-date-picker>
                            </el-form-item>
                            <el-link icon="el-icon-delete" type="danger" :underline="false" @click="del(item, indexC)"
                                     v-if="method != 'view'"></el-link>
                        </div>
                        <el-button type="text" class="addCondition" @click="addCondition(item)" v-if="method != 'view'">
                            +
                            添加页面加载设置
                        </el-button>
                    </el-form-item>
                </div>
                <div v-if="form.metadataFonctionsModelId && form.basicDataId.length">
                    <div class="title">状态变更设置
                        <el-tooltip class="item" effect="light"
                                    content="设置数值：如果所选元数据是系统自动赋值的，选择“设置数值”时，不显示数据录入或选择框，由系统自动赋值。"
                                    placement="right">
                            <el-link icon="el-icon-question" type="primary" :underline="false"></el-link>
                        </el-tooltip>
                    </div>
                    <div v-for="(item, index) in form.statusChangeSettingsList" :key="index"
                         v-if="!item.hasOwnProperty('syncedCode')">
                        <el-form-item
                                :prop="`statusChangeSettingsList[${index}].metadataFonctionsModelDetailId`"
                                :rules="[{required: true, message: '功能按钮不能为空', trigger: 'change'}]"
                                label-width="0px">
                            <el-select v-model="item.metadataFonctionsModelDetailId" placeholder="请选择功能按钮" filterable
                                       @change="metadataFonctionsChange(item)">
                                <el-option v-for="c in functionButton" :key="c.metadataFonctionsModelDetailId"
                                           :label="c.detailName"
                                           :value="c.metadataFonctionsModelDetailId"
                                           v-if="c.disabled == '0'"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                                :prop="`statusChangeSettingsList[${index}].basicCode`"
                                :rules="[{required: true, message: '元数据不能为空', trigger: 'change'}]" label-width="10px">
                            <el-select v-model="item.basicCode" placeholder="请选择" @change="basicCodeChange(item)">
                                <el-option
                                        :key="i"
                                        :label="v.basicName"
                                        :value="v.basicCode"
                                        v-for="(v, i) in item.basicSys">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :prop="`statusChangeSettingsList[${index}].operateType`" label-width="0px">
                            <el-select v-model="item.operateType" placeholder="请选择" @change="operateTypeChange(item)">
                                <el-option
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        v-for="item in $dictUtils.getDictList('operateType')">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                                :prop="`statusChangeSettingsList[${index}].detailList`"
                                :rules="[{required: true, message: '条件值不能为空', trigger: 'change'}]"
                                v-if="item.basicCode && item.basicAssemblyId != '21' && item.basicAssemblyId != '22' && item.operateType == '0'"
                                label-width="10px">
                            <!--单行文本、多行文本-->
                            <el-input v-model.trim="item.detailList" placeholder="请输入"
                                      :maxlength="item.basicAssemblyId == '1' ? 200 : 2000" clearable
                                      :rows="1" :type="item.basicAssemblyId == '2' ? 'textarea' : ''"
                                      v-if="item.basicAssemblyId == '1' || item.basicAssemblyId == '2'"></el-input>
                            <!--数字-->
                            <el-input v-model.trim="item.detailList" placeholder="请输入" clearable maxlength="19"
                                      @input="(v)=>(item.detailList=v.replace(/[^\d-.]/g,''))"
                                      v-if="item.basicAssemblyId == '12'"></el-input>
                            <!--下拉单选、单选框组、下拉多选、多选框组-->
                            <el-select v-model="item.detailList"
                                       :multiple="item.basicAssemblyId == '6' || item.basicAssemblyId == '7'"
                                       placeholder="请选择" clearable
                                       v-if="item.basicAssemblyId == '4' || item.basicAssemblyId == '5' || item.basicAssemblyId == '6' || item.basicAssemblyId == '7' || item.basicAssemblyId == '10'">
                                <el-option v-for="(v,i) in item.basicRangeList" :key="i"
                                           :label="v.basicRange"
                                           :value="v.metadataRangeId"></el-option>
                            </el-select>
                            <!--时间-->
                            <el-time-picker v-model="item.detailList" placeholder="请选择"
                                            value-format="yyyy-MM-dd HH:mm:ss" format="HH:mm:ss"
                                            v-if="item.basicAssemblyId == '8'"></el-time-picker>
                            <!--日期-->
                            <el-date-picker
                                    v-model="item.detailList"
                                    type="datetime"
                                    placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"
                                    format="yyyy-MM-dd HH:mm:ss" v-if="item.basicAssemblyId == '9'">
                            </el-date-picker>
                        </el-form-item>
                        <el-link icon="el-icon-delete" class="m_t1" type="danger" :underline="false"
                                 @click="delStatusChange(index)"
                                 v-if="method != 'view'"></el-link>
                    </div>
                    <el-button type="text" class="addCondition" @click="addStatusChange()" v-if="method != 'view'">+
                        添加状态变更设置
                    </el-button>
                    <div class="title">状态同步设置
                        <el-tooltip class="item" effect="light"
                                    content="设置数值：如果所选元数据是系统自动赋值的，选择“设置数值”时，不显示数据录入或选择框，由系统自动赋值。"
                                    placement="right">
                            <el-link icon="el-icon-question" type="primary" :underline="false"></el-link>
                        </el-tooltip>
                    </div>
                    <div v-for="(item, index) in form.statusChangeSettingsList" :key="index"
                         v-if="item.hasOwnProperty('syncedCode')">
                        <el-form-item
                                :prop="`statusChangeSettingsList[${index}].metadataFonctionsModelDetailId`"
                                :rules="[{required: true, message: '功能按钮不能为空', trigger: 'change'}]"
                                label-width="0px">
                            <el-select v-model="item.metadataFonctionsModelDetailId" placeholder="请选择功能按钮" filterable
                                       @change="metadataFonctionsChange(item)">
                                <el-option v-for="c in functionButton" :key="c.metadataFonctionsModelDetailId"
                                           :label="c.detailName"
                                           :value="c.metadataFonctionsModelDetailId"
                                           v-if="c.disabled == '0'"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                                :prop="`statusChangeSettingsList[${index}].basicCode`"
                                :rules="[{required: true, message: '元数据不能为空', trigger: 'change'}]" label-width="10px">
                            <el-select v-model="item.basicCode" placeholder="请选择" filterable
                                       @change="basicCodeChange(item)">
                                <el-option
                                        :key="i"
                                        :label="v.basicName"
                                        :value="v.basicCode"
                                        v-for="(v, i) in item.basicSys">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :prop="`statusChangeSettingsList[${index}].operateType`" label-width="0px">
                            <el-select v-model="item.operateType" placeholder="请选择" @change="operateTypeChange(item)">
                                <el-option
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        v-for="item in $dictUtils.getDictList('operateType')">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                                :prop="`statusChangeSettingsList[${index}].syncedCode`"
                                :rules="[{required: true, message: '同步状态不能为空', trigger: 'change'}]" label-width="10px"
                                v-if="item.basicCode">
                            <el-select v-model="item.syncedCode" placeholder="请选择" filterable @change="syncedCodeChange(item)">
                                <el-option
                                        :key="i"
                                        :label="v.basicName"
                                        :value="v.basicCode"
                                        v-for="(v, i) in item.syncedCodeField">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                                :prop="`statusChangeSettingsList[${index}].detailList`"
                                :rules="[{required: true, message: '条件值不能为空', trigger: 'change'}]"
                                v-if="item.syncedCode && item.basicAssemblyId != '21' && item.basicAssemblyId != '22' && item.operateType == '0'"
                                label-width="10px">
                            <!--单行文本、多行文本-->
                            <el-input v-model.trim="item.detailList" placeholder="请输入"
                                      :maxlength="item.basicAssemblyId == '1' ? 200 : 2000" clearable
                                      :rows="1" :type="item.basicAssemblyId == '2' ? 'textarea' : ''"
                                      v-if="item.basicAssemblyId == '1' || item.basicAssemblyId == '2'"></el-input>
                            <!--数字-->
                            <el-input v-model.trim="item.detailList" placeholder="请输入" clearable maxlength="19"
                                      @input="(v)=>(item.detailList=v.replace(/[^\d-.]/g,''))"
                                      v-if="item.basicAssemblyId == '12'"></el-input>
                            <!--下拉单选、单选框组、下拉多选、多选框组-->
                            <el-select v-model="item.detailList"
                                       :multiple="item.basicAssemblyId == '6' || item.basicAssemblyId == '7'"
                                       placeholder="请选择" clearable
                                       v-if="item.basicAssemblyId == '4' || item.basicAssemblyId == '5' || item.basicAssemblyId == '6' || item.basicAssemblyId == '7' || item.basicAssemblyId == '10'">
                                <el-option v-for="(v,i) in item.basicRangeList" :key="i"
                                           :label="v.basicRange"
                                           :value="v.metadataRangeId"></el-option>
                            </el-select>
                            <!--时间-->
                            <el-time-picker v-model="item.detailList" placeholder="请选择"
                                            value-format="yyyy-MM-dd HH:mm:ss" format="HH:mm:ss"
                                            v-if="item.basicAssemblyId == '8'"></el-time-picker>
                            <!--日期-->
                            <el-date-picker
                                    v-model="item.detailList"
                                    type="datetime"
                                    placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"
                                    format="yyyy-MM-dd HH:mm:ss" v-if="item.basicAssemblyId == '9'">
                            </el-date-picker>
                        </el-form-item>
                        <el-link icon="el-icon-delete" class="m_t1" type="danger" :underline="false"
                                 @click="delStatusChange(index)"
                                 v-if="method != 'view'"></el-link>
                    </div>
                    <el-button type="text" class="addCondition" @click="addStatusChange('syncedCode')"
                               v-if="method != 'view'">+
                        添加状态同步设置
                    </el-button>
                </div>
            </el-form>
            <div v-show="step == 1 || method == 'view'">
                <el-tabs v-model="basicDataId">
                    <el-tab-pane :label="item.basicDataName" :name="item.basicDataId" v-for="item in basicDataList"
                                 :key="item.basicDataId">
                        <ListData :templateData="item" :method="method" :basicDataId="basicDataId"
                                  :basicDataIdList="form.basicDataIdList" v-if="basicDataFlag"></ListData>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div v-show="step == 3">
                <el-result icon="success" :title="title + '成功'" :subTitle="'业务功能配置信息'+ title + '成功'"></el-result>
            </div>
        </div>
        <div slot="footer" v-if="method != 'view'">
            <el-button size="small" type="primary" @click="next()" v-noMoreClick v-if="step == 0 && !loading">
                下一步
            </el-button>
            <el-button size="small" @click="backUpdate()" v-if="step == 1" :disabled="loading">返回修改</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick v-if="step == 1"
                       :disabled="loading">提交
            </el-button>
            <el-button size="small" @click="finish()" v-if="step == 3">完成</el-button>
            <el-button size="small" type="primary" @click="continueAdd()" v-noMoreClick
                       v-if="step == 3 && method == 'add'">继续新增
            </el-button>
        </div>
        <div slot="footer" v-else>
            <el-button size="small" @click="visible = false">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import ListData from './ListData'

    export default {
        components: {ListData},
        data() {
            var validateLines = (rule, value, callback) => {
                if (!/^\+?[1-9][0-9]*$/.test(value) || value > 1000 || value < 5) {
                    callback(new Error('请输入正确的默认行数（5-1000）'));
                }
                callback();
            };
            return {
                visible: false,
                loading: false,
                title: '',
                method: '',
                step: 0,
                // 基本设置
                form: {
                    tableName: '',
                    basicDataId: [],
                    basicDataIdList: [],
                    metadataFonctionsModelId: '',
                    defautNombre: '',
                    tableDescription: '',
                    forCreate: '1',
                    statusChangeSettingsList: [],
                },
                basicDataIdListOpt: [],
                metadataFonctionsOpt: [],
                dataRule: {
                    tableName: [
                        {required: true, message: '功能（页面）名称不能为空', trigger: 'blur'}
                    ],
                    basicDataId: [
                        {required: true, message: '元数据模板不能为空', trigger: 'change'}
                    ],
                    metadataFonctionsModelId: [
                        {required: true, message: '功能模板不能为空', trigger: 'change'}
                    ],
                    defautNombre: [
                        {required: true, message: '默认行数不能为空', trigger: 'blur'},
                        {validator: validateLines, trigger: 'blur'}
                    ],
                },
                functionButton: [],
                basicSys: [],
                selBasicCode: [],
                // 数据设置
                basicDataId: '',
                basicDataList: [],
                basicDataFlag: false,
            }
        },
        methods: {
            init(row, method) {
                this.getFunctionTemplate()
                this.getMetadataTemplate()
                this.basicDataFlag = false
                this.step = 0
                this.form.basicDataId = []
                this.form.basicDataIdList = []
                this.form.statusChangeSettingsList = []
                this.basicDataId = ''
                this.basicDataList = []
                this.method = method
                if (method === 'add') {
                    this.title = `新增`
                } else if (method === 'edit') {
                    this.title = '修改'
                } else if (method === 'view') {
                    this.title = '查看'
                }
                if (row) {
                    this.form.id = row.id
                } else {
                    this.form.id = ''
                }
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.form.resetFields();
                })
            },
            // 获取元数据模板
            getMetadataTemplate() {
                this.loading = true
                this.$axios(this.api.metadata.selectMetadataBasicDataCleanList, [], 'post').then(data => {
                    if (data.status) {
                        this.basicDataIdListOpt = data.data
                        if (this.method !== 'add') {
                            this.getInfo()
                        } else {
                            this.loading = false
                        }
                    } else {
                        if (this.method == 'add') {
                            this.loading = false
                        }
                    }
                })
            },
            // 获取功能模板
            getFunctionTemplate() {
                this.$axios(this.api.metadata.metadatafonctionsmodelSelectAll).then(data => {
                    if (data.status) {
                        this.metadataFonctionsOpt = data.data
                        this.form = this.recover(this.form, this.form);
                    }
                })
            },
            // 获取数据详情信息  type: 1编辑点下一步
            getInfo(type) {
                this.$axios(this.api.metadata.metadatatableconfigGetById + '?configId=' + this.form.id + '&metadataFonctionsModelId=' + this.form.metadataFonctionsModelId, this.form.basicDataId, 'post').then(data => {
                    if (data.status) {
                        if (type != 1) {
                            this.form = this.recover(this.form, data.data);
                            this.form.basicDataId = []
                            this.form.basicDataIdList.map(item => {
                                this.form.basicDataId.push(item.basicDataId)
                            })
                            this.getBasicSys(1)
                        } else {
                            if (data.data.basicDataIdList.length) {
                                this.loadTabList(data.data.basicDataIdList)
                            }
                        }
                    } else {
                        this.$message.error('查询失败')
                    }
                })
            },
            // 查询已选元数据模板字段
            getBasicSys(type) {
                this.$axios(this.api.metadata.queryUnionBasicDataDetailsByBasicDataIds, this.form.basicDataId, 'post').then(data => {
                    if (data.status) {
                        this.basicSys = data.data
                        if (type == 1) {
                            this.selBasicData(this.form.basicDataId, 1)
                            this.selFunctionTemplate(1)
                        } else {
                            this.loading = false
                        }
                    }
                })
            },
            // 选择元数据模板  type：1回显
            selBasicData(val, type) {
                if (val.length) {
                    this.loading = true
                    this.$axios(this.api.metadata.selectMetadataBasicDataCleanList, val, 'post').then(data => {
                        if (data.status) {
                            data.data.map(item => {
                                this.$set(item, 'basicDataId', item.id)
                            })
                            let list = data.data
                            let list2 = list.filter(v => !this.form.basicDataIdList.some(d => v.id == d.basicDataId))
                            if (!type) {
                                list2.map(v => {
                                    this.$set(v, 'metadataTableConfigLoadsettings', [])
                                })
                            }
                            this.form.basicDataIdList = this.form.basicDataIdList.concat(list2)
                            this.$nextTick(() => {
                                this.form.basicDataIdList = this.form.basicDataIdList.filter(v => val.some(id => v.basicDataId == id))
                            })
                            if (this.method != 'add') {
                                list.map(item => {
                                    this.form.basicDataIdList.map(itemC => {
                                        if (item.id == itemC.basicDataId) {
                                            this.$set(itemC, 'children', item.children)
                                        }
                                    })
                                })
                                this.form.basicDataIdList.map(item => {
                                    if (item.children) {
                                        item.metadataTableConfigLoadsettings.map(itemC => {
                                            this.archivesChange(item, itemC, 1)
                                        })
                                    }
                                })
                            }
                            this.$nextTick(() => {
                                if (!type) {
                                    this.getBasicSys()
                                } else {
                                    this.loading = false
                                }
                            })
                        }
                        this.loading = false
                    })
                } else {
                    this.form.statusChangeSettingsList = []
                    this.form.basicDataIdList = []
                }
            },

            // 选择功能模板
            selFunctionTemplate(type) {
                if (type != 1) {
                    this.form.statusChangeSettingsList = []
                } else {
                    this.loading = true
                }
                if (!this.form.metadataFonctionsModelId) {
                    return
                }
                this.$axios(this.api.metadata.getChangeById + '/' + this.form.metadataFonctionsModelId).then(data => {
                    if (data.status) {
                        this.functionButton = data.data.detailList
                        if (this.method != 'add') {
                            this.form.statusChangeSettingsList.map(item => {
                                this.metadataFonctionsChange(item)
                                this.basicCodeChange(item, 1)
                            })
                        } else {
                            this.loading = false
                        }
                    }
                })
            },
            // 选择元数据字段
            archivesChange(item, itemC, type) {
                let val = item.children.filter(v => v.id == itemC.basicDataDetailId)[0]
                this.$set(itemC, 'basicAssemblyId', val.basicAssemblyId)
                this.$set(itemC, 'basicRangeList', val.basicRangeList)
                this.$set(itemC, 'metadataBasicDataRuleVo', val.metadataBasicDataRuleVo)
                if (type) {
                    if (Array.isArray(itemC.detailList)) {
                        if (itemC.basicAssemblyId != 6 && itemC.basicAssemblyId != 7) {
                            this.$set(itemC, 'detailList', itemC.detailList[0])
                        }
                    }
                } else {
                    if (itemC.basicAssemblyId == '6' || itemC.basicAssemblyId == '7') {
                        this.$set(itemC, 'detailList', [])
                    } else {
                        this.$set(itemC, 'detailList', '')
                    }
                }
            },
            // 选择条件
            conditionChange(itemC) {
                if (itemC.basicAssemblyId == '6' || itemC.basicAssemblyId == '7') {
                    this.$set(itemC, 'detailList', [])
                } else {
                    this.$set(itemC, 'detailList', '')
                }
            },
            // 添加筛选条件
            addCondition(item) {
                item.metadataTableConfigLoadsettings.push({
                    basicDataId: item.basicDataId,
                    conditionApproach: 'and',
                    basicDataDetailId: "",
                    condition: "",
                    detailList: '',
                })
            },
            // 删除筛选条件
            del(item, index) {
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    item.metadataTableConfigLoadsettings.splice(index, 1);
                })
            },
            // 添加状态变更设置 type：syncedCode同步
            addStatusChange(type) {
                let obj = {
                    metadataFonctionsModelDetailId: "",
                    basicCode: '',
                    operateType: '0',
                    detailList: '',
                }
                if (type == 'syncedCode') {
                    obj.syncedCode = ''
                }
                this.form.statusChangeSettingsList.push(obj)
            },
            // 删除状态变更设置
            delStatusChange(index) {
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.form.statusChangeSettingsList.splice(index, 1);
                })
            },
            // 状态变更设置选择按钮 type：syncedCode同步
            metadataFonctionsChange(item) {
                if (item.hasOwnProperty('syncedCode')) {
                    this.$set(item, 'basicSys', JSON.parse(JSON.stringify(this.basicSys.filter(v => v.basicAssemblyId == '16'))))
                } else {
                    this.$set(item, 'basicSys', JSON.parse(JSON.stringify(this.basicSys.filter(v => v.basicAssemblyId != '16'))))
                }
            },
            // 状态变更设置选择元数据字段 type：syncedCode同步; 1数据回显
            basicCodeChange(item, type) {
                let val = item.basicSys.filter(v => v.basicCode == item.basicCode)[0]
                this.$set(item, 'basicAssemblyId', val.basicAssemblyId)
                this.$set(item, 'basicRangeList', val.basicRangeList)
                if (type == 1) {
                    if (item.basicAssemblyId != 6 && item.basicAssemblyId != 7 && !item.hasOwnProperty('syncedCode')) {
                        this.$set(item, 'detailList', item.detailList[0])
                    }
                } else {
                    if (item.basicAssemblyId == '6' || item.basicAssemblyId == '7') {
                        this.$set(item, 'detailList', [])
                    } else {
                        this.$set(item, 'detailList', '')
                    }
                }
                if (item.hasOwnProperty('syncedCode')) {
                    this.$set(item, 'syncedCodeField', [])
                    if(type != 1) {
                        this.$set(item, 'syncedCode', '')
                    }
                    if (val.metadataBasicDataRuleVo && val.metadataBasicDataRuleVo.associationBasicDataId) {
                        this.getSyncedCode(item, val, type)
                    } else {
                        this.$message.warning('该字段暂未关联模板')
                    }
                }
            },
            // 获取同步状态字段
            getSyncedCode(item, val, type) {
                if (val.metadataBasicDataRuleVo && val.metadataBasicDataRuleVo.associationBasicDataId) {
                    this.loading = true
                    this.$axios(this.api.metadata.queryUnionBasicDataDetailsByConfigId, {configId: val.metadataBasicDataRuleVo.associationBasicDataId}).then(data => {
                        if (data.status) {
                            this.$set(item, 'syncedCodeField', data.data)
                            this.$nextTick(() => {
                                if(type == 1) {
                                    this.syncedCodeChange(item, type)
                                }
                            })
                        }
                        this.loading = false
                    })
                }
            },
            // 选择同步状态
            syncedCodeChange(item, type) {
                let val = item.syncedCodeField.filter(v => v.basicCode == item.syncedCode)[0]
                if(!val) {
                   return
                }
                this.$set(item, 'basicAssemblyId', val.basicAssemblyId)
                this.$set(item, 'basicRangeList', val.basicRangeList)
                if (type == 1) {
                    if (item.basicAssemblyId != 6 && item.basicAssemblyId != 7) {
                        this.$set(item, 'detailList', item.detailList[0])
                    }
                } else {
                    if (item.basicAssemblyId == '6' || item.basicAssemblyId == '7') {
                        this.$set(item, 'detailList', [])
                    } else {
                        this.$set(item, 'detailList', '')
                    }
                }
            },
            // 选择操作类型
            operateTypeChange(item) {
                this.$set(item, 'detailList', null)
            },
            // 下一步
            next() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        let p = this.dataPackaging()
                        this.$nextTick(() => {
                            this.$axios(this.api.metadata.checkConfigDataExistence, p, 'post').then(data => {
                                if (data.status) {
                                    this.step++
                                    if (this.form.id) {
                                        this.loading = true
                                        this.getInfo(1)
                                    } else {
                                        this.getAllTemplateList()
                                    }
                                } else {
                                    this.loading = false
                                    this.$message.error(data.msg);
                                }
                            })
                        })
                    }
                })
            },
            // 查询模板列表数据
            getAllTemplateList() {
                this.loading = true
                this.$axios(this.api.metadata.selectModelAndBasicData + '?metadataFonctionsModelId=' + this.form.metadataFonctionsModelId, this.form.basicDataId, 'post').then(data => {
                    if (data.status) {
                        this.loadTabList(data.data)
                    } else {
                        this.loading = false
                    }
                })
            },
            // 加载tab列表
            loadTabList(data) {
                this.basicDataFlag = false
                this.basicDataId = data.length ? data[0].basicDataId : ''
                this.basicDataList = data
                this.basicDataList.map(item => {
                    this.$set(item, 'tableListPaging', item.tableList)
                    this.$set(item, 'whereListPaging', item.whereList)
                    this.$set(item, 'pageFonctionsListPaging', item.pageFonctionsList)
                    this.$set(item, 'tableFonctionsListPaging', item.tableFonctionsList)
                    this.$set(item, 'fromFonctionsListPaging', item.fromFonctionsList)
                })
                this.$nextTick(() => {
                    this.basicDataFlag = true
                    this.loading = false
                })
            },
            // 返回修改
            backUpdate() {
                this.$confirm(`您当前设置的信息尚未保存，是否保存后再跳转?`, '保存提示', {
                    confirmButtonText: '保存并跳转',
                    cancelButtonText: '直接跳转',
                    type: 'warning'
                }).then(() => {
                    this.doSubmit(1)
                }).catch(() => {
                    this.step--
                })
            },
            // 提交  type：1返回修改保存
            doSubmit(type) {
                this.loading = true
                let p = this.dataPackaging()
                this.$nextTick(() => {
                    this.$axios(this.api.metadata.metadatatableconfigSave, p, 'post').then(data => {
                        if (data.status) {
                            if (type == 1) {
                                this.form.id = data.data
                                this.step = 0
                            } else {
                                this.step = 3
                            }
                        } else {
                            this.$message.error(data.msg);
                        }
                        this.loading = false
                    })
                })
            },
            // 数据打包
            dataPackaging() {
                let p = JSON.parse(JSON.stringify(this.form))
                p.basicDataIdList.map(item => {
                    item.metadataTableConfigLoadsettings.map(item2 => {
                        if (item2.basicAssemblyId != 6 && item2.basicAssemblyId != 7 && !Array.isArray(item2.detailList)) {
                            if(item2.detailList) {
                                item2.detailList = item2.detailList.split(',')
                            } else {
                                item2.detailList = []
                            }
                        }
                    })
                })
                this.basicDataList.map((item2) => {
                    p.basicDataIdList.map((item1) => {
                        if (item2.basicDataId == item1.basicDataId) {
                            let json = {
                                'metadataTableConfigLoadsettings': item1.metadataTableConfigLoadsettings
                            };
                            Object.assign(item2, json);
                            return item2;
                        }
                    })
                })
                p.statusChangeSettingsList.map(item => {
                    if (item.basicAssemblyId != 6 && item.basicAssemblyId != 7 && !Array.isArray(item.detailList)) {
                        if(item.detailList) {
                            item.detailList = item.detailList.split(',')
                        } else {
                            item.detailList = []
                        }
                    }
                })
                p.basicDataIdList = this.basicDataList
                return p
            },
            // 完成
            finish() {
                this.visible = false
                this.$emit('refreshDataList')
            },
            // 继续新增
            continueAdd() {
                this.$emit('refreshDataList')
                this.init(null, 'add')
            },
            // 获取条件字典
            getMethodCode(item) {
                let condition = this.$dictUtils.getDictList('condition')
                let opt = condition.filter(v => v.value != '>=' && v.value != '<=')
                if (item.basicAssemblyId == '8' || item.basicAssemblyId == '9' || item.basicAssemblyId == '12') {
                    opt = condition.filter(v => v.value != '%' && v.value != '!%')
                }
                return opt
            },
        }
    }
</script>

<style scoped>

    .form .formItem {
        width: 48% !important;
    }

    .formItem >>> .el-form-item__content {
        width: calc(100% - 160px) !important;
    }

    .title {
        font-size: 14px;
        color: #000;
        margin: 10px 0 20px;
        font-weight: bold;
    }

    .methodSel {
        width: 80px !important;
    }
</style>
